import type { Individual } from '@api/btlApplicationForm/types';

export function ensureAddressListHasCurrentEntry<T extends object>(addressList: T[] | undefined | null): T[] {
  if (addressList?.length) {
    return addressList;
  }

  return [{} as T];
}

export function mapIndividualToFormValues(individual?: Individual): Record<string, unknown> {
  if (!individual) {
    return { addressList: [{}] };
  }

  const {
    addressHistory: addressList = [],
    contactDetails,
    previousTitle,
    previousFirstName,
    previousMiddleName,
    previousLastName,
    expectedGrossIncome: grossIncome,
    ...rest
  } = individual;

  const transformedAddressList = addressList.map(address => {
    address.address['isManual'] = true;
    return address;
  });

  return {
    ...rest,
    addressList: ensureAddressListHasCurrentEntry(transformedAddressList),
    previousNames: previousFirstName
      ? [
          {
            title: previousTitle,
            firstName: previousFirstName,
            middleName: previousMiddleName,
            lastName: previousLastName,
          },
        ]
      : [],
    email: contactDetails?.find(contact => contact.contactType === 'EMAIL')?.contact,
    phoneNumber: contactDetails?.find(contact => contact.contactType === 'PHONE')?.contact,
    grossIncome,
  };
}
